const getTimeInHMSFormat = (hours: number, minutes: number, seconds: number) =>
  hours
    ? `${hours}h ${minutes}m ${seconds.toFixed(0)}s`
    : minutes
    ? `${minutes}m ${seconds.toFixed(0)}s`
    : `${seconds.toFixed(0)}s`;

export default getTimeInHMSFormat;
